import {Slider} from '../../../../bd-site/Resources/Private/JavaScript/Slider.js';

const STORAGE_KEY_BD_EXPERIENCE = 'bd_experience';

export class Selection {
    divisions;
    topics;
    content;
}

export class Experience {
    slugs;
    selection;
    sliders;

    static count = 0;
    static loadedSlides = [];

    constructor() {
        this.sliders = new Map();
        this.selection = new Selection();
        this.slugs = new Selection();
        this.form = document.querySelector('.c-experience__form');
        this.experienceBaseUrlInput = document.querySelector('.c-experience__baseUrl');
        this.buttonReset = document.querySelector('.c-experience__button-reset');
        this.fetchResultsUri = null;
        if (document.querySelector('[data-bdexperience-fetch-results-uri]')) {
            this.fetchResultsUri = document.querySelector('[data-bdexperience-fetch-results-uri]').dataset.bdexperienceFetchResultsUri;
        }

        if (this.form) {
            this.resetBusyState();
            if (this.buttonReset) {
                this.initResetButton()
            }

            if (this.form.classList.contains('c-experience__form--reload-on-change')) {
                this.initResultForm();
            } else {
                this.initSingleForm();
            }

            this.initSlider();
        }
    }

    initSingleForm() {
        this.formSubmit = document.querySelector('.c-experience__button-continue');
        this.filters = document.querySelectorAll('.c-experience__filter-checkbox');
        this.filters = document.querySelectorAll('.c-experience__filter-checkbox');
        this.checkSubmitButton();

        this.form.addEventListener('change', () => {
            this.checkSubmitButton();
        });
        if (this.formSubmit) {
            this.formSubmit.addEventListener('click', () => {
                this.submitForm();
            });
        }
    }

    initResultForm() {
        this.filters = document.querySelectorAll('.c-experience__filter-checkbox');

        if (this.form.dataset.simpleForm === '1' && this.form.dataset.step === 'results') {
            this.buttonRedirect = document.querySelector('.c-experience__button-redirect');
            this.buttonRedirect.addEventListener('click', () => {
                window.location.href = this.experienceBaseUrlInput.value;
            });
        }

        this.filters.forEach(filterItem => {
            filterItem.addEventListener('change', (event) => {
                let checkbox = event.target;

                if (document.querySelectorAll('.c-experience-all-filters__col--' + checkbox.dataset.filter + ' .c-experience__filter-checkbox:checked').length === 0) {
                    let lastCheckbox = event.target;
                    lastCheckbox.checked = true;
                    lastCheckbox.classList.add('has-error');
                    setTimeout(() => {
                        lastCheckbox.classList.remove('has-error');
                    }, 1000);
                } else {
                    Experience.loadedSlides = [];
                    this.submitForm();
                    this.clearPaginationState();
                }
            });
        });
    }

    initResetButton() {
        let nextLinkElement = document.querySelector('.c-experience__next-link');
        this.buttonReset.addEventListener('click', () => {
            history.replaceState({}, "", nextLinkElement.dataset.baseUrl);
        });
    }

    checkSubmitButton() {
        if (this.formSubmit) {
            this.hideFormSubmit();
            this.filters.forEach((item) => {
                if (item.checked) {
                    this.showFormSubmit();
                }
            });
        }
    }

    showFormSubmit() {
        this.formSubmit.classList.remove('inactive');
    }

    hideFormSubmit() {
        this.formSubmit.classList.add('inactive');
    }

    resetBusyState() {
        document.querySelectorAll('.c-experience').forEach(turboFrame => {
            if (turboFrame.attributes.getNamedItem('aria-busy')) {
                turboFrame.attributes.removeNamedItem('aria-busy');
            }
            if (turboFrame.attributes.getNamedItem('busy')) {
                turboFrame.attributes.removeNamedItem('busy');
            }
        });
    }

    updateSlugs() {
        this.slugs.divisions = [];
        this.slugs.topics = [];
        this.slugs.content = [];

        this.form.querySelectorAll('.c-experience__filter-checkbox:checked, .c-experience__filter-hidden').forEach(checkbox => {
            let checkboxInput = checkbox;
            this.slugs[checkboxInput.dataset.filter].push(checkboxInput.dataset.slug)
        });
    }

    submitForm() {
        this.updateSlugs();
        this.storeSelection().then(response => {
            let nextLinkElement = document.querySelector('.c-experience__next-link');
            let baseUrl = nextLinkElement.dataset.baseUrl;
            let nextLinkHref = '';

            if (this.slugs.divisions.length > 0) {
                nextLinkHref += nextLinkElement.dataset.slugDivisions + '/' + this.slugs.divisions.join('+') + '/';

                if (this.slugs.topics.length > 0) {
                    nextLinkHref += nextLinkElement.dataset.slugTopics + '/' + this.slugs.topics.join('+') + '/';
                }
                if (this.slugs.content.length > 0) {
                    nextLinkHref += nextLinkElement.dataset.slugContent + '/' + this.slugs.content.join('+') + '/';
                }
            }

            if (this.form.dataset.simpleForm === '1') {
                if (this.form.dataset.step === 'topics') {
                    window.location.href = this.experienceBaseUrlInput.value + nextLinkHref;
                } else {
                    this.form.requestSubmit();
                }
            } else {
                history.replaceState({}, "", baseUrl + nextLinkHref);
                this.form.requestSubmit();
            }
        });
    }

    storeSelection() {
        this.selection.divisions = [];
        this.selection.topics = [];
        this.selection.content = [];

        this.form.querySelectorAll('.c-experience__filter-checkbox:checked, .c-experience__filter-hidden').forEach(checkbox => {
            let checkboxInput = checkbox;
            this.selection[checkboxInput.dataset.filter].push(checkboxInput.value)
        });

        return fetch('/api/bd-experience/storage/set/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.selection)
        })
    }

    loadMoreResults(offset, contentType, resultContainer) {
        if (!this.fetchResultsUri) {
            return false;
        }
        let fetchResultsUri = this.fetchResultsUri
            .replace("_offset_", offset)
            .replace("_contenttype_", contentType);
        return fetch(fetchResultsUri,
            {
                'method': "GET"
            })
            .then(response => {
                return response.text();
            })
            .then(result => {
                const parser = new DOMParser();
                const newDocument = parser.parseFromString(result, 'text/html');
                const elements = newDocument.querySelector('.tx-bdexperience').children;

                Array.from(elements).forEach(element => {
                    resultContainer.append(element);
                });
            });
    }

    storePaginationState(paginationType, showRecords, offset) {
        if (this.form.dataset.filterIdentifier) {
            let paginationState = {
                'filterIdentifier': this.form.dataset.filterIdentifier,
                'type': paginationType,
                'showRecords': showRecords
            }

            if (Experience.loadedSlides[paginationType] === undefined) {
                Experience.loadedSlides[paginationType] = [];
            }

            if (Experience.loadedSlides[paginationType][showRecords] === undefined) {
                Experience.loadedSlides[paginationType][showRecords] = true;
                const slidesContainer = document.querySelector('#' + paginationType + '-slides');
                if (slidesContainer && !slidesContainer.querySelector('.d-none')) {
                    let loadedResults = this.loadMoreResults(offset, paginationType, slidesContainer);
                    if (loadedResults !== false) {
                        loadedResults.then(() => {
                            // console.log('more results loaded');
                        });
                    }
                }
            }

            fetch('/api/bd-experience/storage/setPaginationStates/', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(paginationState)
            })
                .then(response => response.json())
                .then(response => {
                    //console.log(JSON.stringify(response))
                })
        }
    }

    clearPaginationState() {
        fetch('/api/bd-experience/storage/clearPaginationStates/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => {
                //console.log(JSON.stringify(response))
            })
    }

    initSlider() {
        let mediaBreakpointDownLg = '(max-width: 991px)';

        window.addEventListener('resize', (event) => {
            if (window.matchMedia(mediaBreakpointDownLg).matches) {
                this.mountAllSlider();
            } else {
                this.destroyAllSlider();
            }
        });

        if (window.matchMedia(mediaBreakpointDownLg).matches) {
            this.mountAllSlider();
        }
    }

    mountAllSlider() {
        document.querySelectorAll('.glide-experience').forEach(sliderElement => {
            this.mountSlider(sliderElement, 0);
        });
    }

    mountSlider(sliderElement, startAt) {
        if (!(sliderElement instanceof Element)) {
            return;
        }
        startAt = startAt || 0;
        let sliderId = sliderElement.id;
        let slides = sliderElement.querySelectorAll('.glide-experience__slide');

        if (slides.length > 1 && !this.sliders.get(sliderId)) {
            // The result grid only becomes a slider below lg. Add the Swiper markup
            // classes on mount (and strip them on destroy) so the desktop Bootstrap
            // grid is left untouched.
            sliderElement.classList.add('swiper');
            sliderElement.classList.add('swiper--arrows-overlay');
            sliderElement.querySelector('.glide-experience__slides').classList.add('swiper-wrapper');
            slides.forEach(slide => slide.classList.add('swiper-slide'));

            let swiper = new Slider(sliderElement, JSON.stringify({
                spaceBetween: 12,
                rewind: false,
                arrows: 'overlay',
            }));
            if (startAt > 0) {
                swiper.slideTo(startAt, 0, false);
            }

            this.sliders.set(sliderId, swiper);

            if (Experience.loadedSlides[sliderId] === undefined) {
                Experience.loadedSlides[sliderId] = [];
            }

            swiper.on('slideChange', () => {
                let index = swiper.activeIndex,
                    offset = index + 2;
                if (Experience.loadedSlides[sliderId][offset] === undefined) {
                    Experience.loadedSlides[sliderId][offset] = true;
                    let slidesContainer = document.querySelector('#' + sliderId + '-slides');
                    let slidesCount = slidesContainer.querySelectorAll('.glide-experience__slide').length;
                    if (slidesContainer && slidesCount === offset) {
                        let loadedResults = this.loadMoreResults(offset, sliderId, slidesContainer);
                        if (loadedResults !== false) {
                            loadedResults.then(() => {
                                this.destroySlider(sliderId);
                                this.mountSlider(sliderElement, index);
                            });
                        }
                    }
                }
            });
        } else if (slides.length === 1 && this.sliders.get(sliderId)) {
            this.destroySlider(sliderId);
        }
    }

    destroyAllSlider() {
        Array.from(this.sliders.keys()).forEach(sliderId => {
            this.destroySlider(sliderId);
        });
    }

    destroySlider(sliderId) {
        let swiper = this.sliders.get(sliderId);
        if (swiper) {
            let sliderElement = swiper.el;
            swiper.destroy(true, true);
            if (sliderElement) {
                sliderElement.classList.remove('swiper');
                sliderElement.classList.remove('swiper--arrows-overlay');
                let wrapper = sliderElement.querySelector('.glide-experience__slides');
                if (wrapper) {
                    wrapper.classList.remove('swiper-wrapper');
                }
                sliderElement.querySelectorAll('.glide-experience__slide').forEach(slide => {
                    slide.classList.remove('swiper-slide');
                });
            }
            this.sliders.delete(sliderId);
        }
    }

}

addEventListener('turbo:load', (event) => {
    window['BigExperience'] = new Experience();
});
addEventListener('turbo:frame-load', (event) => {
    window['BigExperience'] = new Experience();
});

// Wait for UserCentricsService to be available
const setupExperienceConsentListeners = () => {
    if (!window.UserCentricsService) {
        setTimeout(setupExperienceConsentListeners, 100);
        return;
    }

    const Cookies = window['Cookies'];
    const BigExperience = window['BigExperience'];

    if (typeof Cookies === 'undefined') return;

    const handleConsentChange = () => {
        const hasAdvancedSearch = window.UserCentricsService.isServiceEnabled('BD Advanced Search');
        const hasBigExperience = window.UserCentricsService.isServiceEnabled('Big Experience');

        if (hasAdvancedSearch || hasBigExperience) {
            //console.log('Big Experience has consent');
            if (typeof Cookies.get(STORAGE_KEY_BD_EXPERIENCE) === 'undefined') {
                Cookies.set(STORAGE_KEY_BD_EXPERIENCE, '');
                if (typeof BigExperience !== 'undefined') {
                    BigExperience.storeSelection();
                }
            }
        } else {
            //console.log('Big Experience has no consent');
            Cookies.remove(STORAGE_KEY_BD_EXPERIENCE);
        }
    };

    // Register listeners for both services
    window.UserCentricsService.onConsentChange('BD Advanced Search', handleConsentChange);
    window.UserCentricsService.onConsentChange('Big Experience', handleConsentChange);

    // Check initial state
    handleConsentChange();
};

setupExperienceConsentListeners();